import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function SettingsApplicationsIcon(props: IconProps) {
    return <Icon {...props} iconKey={"settings_applications"}/>
}
